export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/seller_page_perseus/Certificate.5a4cacd.svg";